import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Popup from "reactjs-popup";
import "./EditableIntroduction.css"
import Introduction from "../../../../clients/PastGeb/components/Introduction/Introduction";
import fetchPastEditionIntroduction from "../../../../clients/PastGeb/components/Introduction/packages/fetchPeIntroduction";
import UpdatePastIntroduction from "./packages/updateIntroduction";

const EditButton = ({ id }) => {
    const [countries, setCountries] = useState(0);
    const [participants, setParticipants] = useState(0);
    const [businessIdeas, setBusinessIdeas] = useState(0);
    const [speakers, setSpeakers] = useState(0);
    const [contents, setcontents] = useState('');
    const [btnLoading, setBtnLoading] = useState(false);

    let [introductionData, setIntroductionData] = useState({});
    // console.log("id = ", id)

    useEffect(() => {
        if (id)
            fetchPastEditionIntroduction({
                editionId: id,
                setIntroductionData: setIntroductionData
            })
    }, []);

    useEffect(() => {
        setCountries(introductionData.countries ?? 0);
        setParticipants(introductionData.participants ?? 0);
        setBusinessIdeas(introductionData.businessIdeas ?? 0);
        setSpeakers(introductionData.speakers ?? 0);
        setcontents(introductionData.content ?? 0);
    }, [introductionData]);

    function refreshPage() {
        window.location.reload();
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        let success = await UpdatePastIntroduction({
            btnLoading: btnLoading,
            setBtnLoading: setBtnLoading,
            editionId: id,
            countries: countries,
            participants: participants,
            businessIdeas: businessIdeas,
            speakers: speakers,
            content: contents,
        });
        if (success) {
            refreshPage();
        }
    };

    return (
        <Popup
            trigger={
                <div className="ehp_edit_btn">
                    Edit
                </div>
            }
            modal
        >
            {(close) => {
                return (
                    <div className="ehp_edit_popup">
                        <div className="ehp_inner_container pg_inner_container">
                            <form className="ehp_form_container" onSubmit={handleSubmit}>
                                <h1 className="ehp_form_container_header">Edit Introduction</h1>
                                <div className="ehp_form_top">
                                    <div className="ehp_form_left">
                                        <label htmlFor="countries" className="geb_form_label">
                                            Enter Countries:
                                        </label>
                                        <input
                                            id="countries"
                                            type="number"
                                            value={countries}
                                            onChange={(e) => {
                                                setCountries(e.target.value);
                                            }}
                                            className="ge_input_field ehp_input_field"
                                            placeholder=""
                                            required
                                        ></input>
                                        <label htmlFor="participants" className="geb_form_label">
                                            Enter participants:
                                        </label>
                                        <input
                                            id=""
                                            type="number"
                                            value={participants}
                                            onChange={(e) => {
                                                setParticipants(e.target.value);
                                            }}
                                            className="ge_input_field ehp_input_field"
                                            placeholder=""
                                            required
                                        ></input>
                                        <label htmlFor="businessIdeas" className="geb_form_label">
                                            Enter Business Ideas Pitched:
                                        </label>
                                        <input
                                            id="businessIdeas"
                                            type="number"
                                            value={businessIdeas}
                                            onChange={(e) => {
                                                setBusinessIdeas(e.target.value);
                                            }}
                                            className="ge_input_field ehp_input_field"
                                            placeholder=""
                                            required
                                        ></input>
                                        <label htmlFor="speakers" className="geb_form_label">
                                            Enter Speakers:
                                        </label>
                                        <input
                                            id="speakers"
                                            type="number"
                                            value={speakers}
                                            onChange={(e) => {
                                                setSpeakers(e.target.value);
                                            }}
                                            className="ge_input_field ehp_input_field"
                                            placeholder=""
                                            required
                                        ></input>
                                    </div>
                                    <div className="ehp_form_right">
                                        <label htmlFor="Contents" className="geb_form_label">
                                            Enter Contents:
                                        </label>
                                        <textarea
                                            style={{
                                                height: "30rem",
                                                width: "42rem"
                                            }}
                                            id="Contents"
                                            value={contents}
                                            onChange={(e) => {
                                                setcontents(e.target.value);
                                            }}
                                            className=" ehp_input_field"
                                            placeholder=""
                                            required
                                        ></textarea>
                                    </div>
                                </div>
                                <div className="ehp_form_bottom">
                                    <input
                                        type="submit"
                                        className="ehp_submit primary_btn"
                                        value={btnLoading ? "Loading..." : "Submit"}
                                    />
                                    <input
                                        type="button"
                                        className="ehp_cancel primary_btn "
                                        onClick={() => {
                                            close();
                                        }}
                                        value={"Cancel"}
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                );
            }}
        </Popup>
    );
};

const EditableIntroduction = ({ id }) => {

    return (
        <div className="editableHomePage_container">
            <EditButton id={id} />
            <Introduction id={id} />
        </div>
    );
};

export default EditableIntroduction;
